(function () {
  var ANIM_DURATION = 1100;
  var animating = false;

  function getHeaderCartIcon() {
    var icon = document.querySelector('#cart-icon-bubble') ||
      document.querySelector('header a[href*="/cart"]');
    if (!icon) return null;
    var r = icon.getBoundingClientRect();
    if (r.top >= 0 && r.bottom <= window.innerHeight && r.left >= 0 && r.right <= window.innerWidth) {
      return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
    }
    return null;
  }

  function getCornerCartItemPosition() {
    var itemImg = document.querySelector('#corner-cowi-cart-item-0 img, #corner-cowi-cart-item-list-item-image-0 img');
    if (itemImg) {
      var r = itemImg.getBoundingClientRect();
      if (r.width > 0 && r.height > 0) {
        return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
      }
    }
    return null;
  }

  function waitForStableItemPosition(timeout) {
    return new Promise(function (resolve) {
      var startTime = Date.now();
      var maxTime = timeout || 2000;
      var lastPos = null;
      var stableCount = 0;
      var STABLE_THRESHOLD = 3;

      function checkPosition() {
        if (Date.now() - startTime > maxTime) {
          var pos = getCornerCartItemPosition();
          if (pos) { resolve(pos); return; }
          var isMobile = window.innerWidth < 640;
          var slideWidth = isMobile ? window.innerWidth : 420;
          resolve({ x: window.innerWidth - slideWidth + 60, y: 340 });
          return;
        }

        var pos = getCornerCartItemPosition();
        if (pos) {
          if (lastPos && Math.abs(pos.x - lastPos.x) < 2 && Math.abs(pos.y - lastPos.y) < 2) {
            stableCount++;
            if (stableCount >= STABLE_THRESHOLD) {
              resolve(pos);
              return;
            }
          } else {
            stableCount = 0;
          }
          lastPos = pos;
        }

        requestAnimationFrame(checkPosition);
      }

      var observer = new MutationObserver(function () {
        var p = getCornerCartItemPosition();
        if (p) {
          observer.disconnect();
          lastPos = p;
          stableCount = 0;
          requestAnimationFrame(checkPosition);
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });

      requestAnimationFrame(checkPosition);
    });
  }

  function getCenter(el) {
    var r = el.getBoundingClientRect();
    return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
  }

  function findVisibleImage(container) {
    var selectors = ['.product__media img', '.card__media img', 'img'];
    for (var s = 0; s < selectors.length; s++) {
      var imgs = container.querySelectorAll(selectors[s]);
      for (var i = 0; i < imgs.length; i++) {
        var r = imgs[i].getBoundingClientRect();
        if (r.width > 50 && r.height > 50 && r.top < window.innerHeight && r.bottom > 0) {
          return imgs[i];
        }
      }
    }
    return null;
  }

  function findVisualOrigin(target) {
    var img = null;
    var container = target.closest('product-form, .card-wrapper, .grid__item, form');
    if (container) img = findVisibleImage(container);

    if (!img) {
      var gallery = document.querySelector('media-gallery, .product__media-wrapper');
      if (gallery) img = findVisibleImage(gallery);
    }

    if (!img) img = findVisibleImage(document);

    var fallbackSrc = null;
    if (!img) {
      var anyImg = (container && container.querySelector('img[src*="/products/"]')) ||
        document.querySelector('.product__media img, media-gallery img');
      if (anyImg) fallbackSrc = anyImg.currentSrc || anyImg.src;
    }

    return {
      point: img ? getCenter(img) : getCenter(target),
      imgSrc: img ? (img.currentSrc || img.src) : fallbackSrc
    };
  }

  function createSoulAt(point, imgSrc) {
    var soul = document.createElement('div');
    soul.className = 'fly-soul';
    soul.style.left = point.x + 'px';
    soul.style.top = point.y + 'px';

    if (imgSrc) {
      var img = document.createElement('img');
      img.src = imgSrc;
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      soul.appendChild(img);
    }

    document.body.appendChild(soul);
    return soul;
  }

  function animateCartLanding() {
    var cartIcon = document.querySelector('#cart-icon-bubble');
    if (!cartIcon) return;
    var r = cartIcon.getBoundingClientRect();
    if (r.top < 0 || r.bottom > window.innerHeight) return;

    cartIcon.classList.add('cart-icon-wiggle');
    cartIcon.addEventListener('animationend', function handler() {
      cartIcon.classList.remove('cart-icon-wiggle');
      cartIcon.removeEventListener('animationend', handler);
    });

    var bubble = cartIcon.querySelector('.cart-count-bubble');
    if (bubble) {
      bubble.classList.add('cart-badge-bounce');
      bubble.addEventListener('animationend', function handler() {
        bubble.classList.remove('cart-badge-bounce');
        bubble.removeEventListener('animationend', handler);
      });
    }
  }

  function flySoul(fromPoint, imgSrc, toPoint, options) {
    var onDone = (options && options.onDone) || null;
    var landingEffect = (options && options.landingEffect) || false;

    var soul = createSoulAt(fromPoint, imgSrc);
    var dx = toPoint.x - fromPoint.x;
    var dy = toPoint.y - fromPoint.y;

    var isCornerTarget = toPoint.x > window.innerWidth - 500;
    var arcHeight = isCornerTarget ? 50 : 120;
    var midX = fromPoint.x + dx * 0.5;
    var midY = fromPoint.y + dy * 0.5 - arcHeight;

    var endScale = landingEffect ? 0.12 : 0.35;
    var midScale = landingEffect ? 0.45 : 1.1;
    var startScale = landingEffect ? 1 : 1;
    var endOpacity = landingEffect ? 0.3 : 0.7;

    var anim = soul.animate(
      [
        { opacity: 0, transform: 'translate(-50%,-50%) scale(' + startScale + ')', offset: 0 },
        { opacity: 1, transform: 'translate(-50%,-50%) scale(' + startScale + ')', offset: 0.08 },
        {
          transform: 'translate(' + (midX - fromPoint.x) + 'px,' + (midY - fromPoint.y) + 'px) scale(' + midScale + ')',
          opacity: 1,
          offset: 0.5
        },
        {
          transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + endScale + ')',
          opacity: endOpacity,
          offset: 1
        }
      ],
      { duration: ANIM_DURATION, easing: 'cubic-bezier(.2,.8,.2,1)', fill: 'forwards' }
    );

    anim.onfinish = function () {
      if (landingEffect) {
        var pop = soul.animate(
          [
            { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(0.12)', opacity: 0.3, boxShadow: '0 0 0 0 rgba(0,0,0,0)' },
            { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(0.35)', opacity: 0.8, boxShadow: '0 0 20px 8px rgba(0,0,0,0.15)' },
            { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(0.05)', opacity: 0, boxShadow: '0 0 0 0 rgba(0,0,0,0)' }
          ],
          { duration: 350, easing: 'cubic-bezier(.34,1.56,.64,1)', fill: 'forwards' }
        );

        var ripple = document.createElement('div');
        ripple.className = 'fly-soul-ripple';
        ripple.style.left = (fromPoint.x + dx) + 'px';
        ripple.style.top = (fromPoint.y + dy) + 'px';
        document.body.appendChild(ripple);
        ripple.addEventListener('animationend', function () { ripple.remove(); });

        var itemImg = document.querySelector('#corner-cowi-cart-item-0 img, #corner-cowi-cart-item-list-item-image-0 img');
        if (itemImg) {
          itemImg.classList.add('cart-item-land');
          itemImg.addEventListener('animationend', function handler() {
            itemImg.classList.remove('cart-item-land');
            itemImg.removeEventListener('animationend', handler);
          });
        }

        pop.onfinish = function () {
          soul.remove();
          if (onDone) onDone();
        };
      } else {
        soul.remove();
        if (onDone) onDone();
      }
    };
  }

  function runAnimation(btn) {
    if (animating) return;
    animating = true;

    var origin = findVisualOrigin(btn);
    var headerIcon = getHeaderCartIcon();

    if (headerIcon) {
      flySoul(origin.point, origin.imgSrc, headerIcon, {
        onDone: function () {
          animateCartLanding();
          animating = false;
        }
      });
    } else {
      waitForStableItemPosition(2000).then(function (targetPos) {
        flySoul(origin.point, origin.imgSrc, targetPos, {
          landingEffect: true,
          onDone: function () { animating = false; }
        });
      });
    }
  }

  function setupCartUpdateListener() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            var bubble = document.querySelector('.cart-count-bubble');
            if (bubble) {
              bubble.classList.add('count-pop');
              bubble.addEventListener('animationend', function handler() {
                bubble.classList.remove('count-pop');
                bubble.removeEventListener('animationend', handler);
              });
            }
          });
        });
      });
    }
  }

  function handleClick(e) {
    var btn = e.target.closest(
      'button[name="add"], button[type="submit"], ' +
      'button.quick-add__submit, button[data-add-to-cart], ' +
      'button.product-form__submit, .product-form__submit, ' +
      'button[aria-label*="Add"], button[aria-label*="Añadir"], button[aria-label*="Agregar"], ' +
      'button[aria-label*="carrito"], button[aria-label*="cart"], ' +
      '[data-corner-add-to-cart], .corner-add-to-cart'
    );
    if (!btn) return;
    if (btn.closest('.corner-widget-wrapper, #corner-cowi-open-wrapper, .widgets-by-corner')) return;

    runAnimation(btn);
  }

  function handleFormSubmit(e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"], form[data-type="add-to-cart-form"]')) return;
    if (form.closest('.corner-widget-wrapper, #corner-cowi-open-wrapper, .widgets-by-corner')) return;

    var btn = e.submitter || form.querySelector('[type="submit"]') || form;
    runAnimation(btn);
  }

  function attachListeners() {
    document.addEventListener('click', handleClick, true);
    document.addEventListener('submit', handleFormSubmit, true);
    setupCartUpdateListener();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachListeners);
  } else {
    attachListeners();
  }
})();
